import React from "react";
import { sortArtists } from "./sortArtists";
import BaseReactSelectDropdown from "components/dropdowns/reactselect/BaseReactSelectDropdown";

interface Props {
  allArtists: server.dto.ArtistSmall[]
  recentlyUsed: number[]

  onChanged: (artist: server.dto.ArtistSmall | undefined) => void
  value: server.dto.ArtistSmall
  excludeKeys?: number[]
  error?: boolean
  autoFocus?: boolean
}

const ArtistPickerDropdown = (props: Props) => {
  const artistList: server.dto.ArtistSmall[] =
        sortArtists(props.allArtists, props.recentlyUsed)
          .filter(a => props.excludeKeys ? !props.excludeKeys.includes(a.artistId) : true);

  return <BaseReactSelectDropdown
    excludeKeys={[]}
    options={artistList}
    getLabel={a => a.name}
    getValue={a => a.artistId}

    value={props.value}
    onChange={props.onChanged}
    config={{
      isSearchable: true,
      focusOnMount: props.autoFocus,
      placeholder: RESX.GeneralLabels.Search,
      hasError: props.error
    }}
  />;
};

export default ArtistPickerDropdown;